import { z } from 'zod';
// Discogs media condition grades (Goldmine standard)
export const discogsMediaConditionSchema = z.enum([
    'Mint (M)',
    'Near Mint (NM or M-)',
    'Very Good Plus (VG+)',
    'Very Good (VG)',
    'Good Plus (G+)',
    'Good (G)',
    'Fair (F)',
    'Poor (P)',
]);
// Discogs sleeve/cover condition grades
export const discogsSleeveConditionSchema = z.enum([
    'Mint (M)',
    'Near Mint (NM or M-)',
    'Very Good Plus (VG+)',
    'Very Good (VG)',
    'Good Plus (G+)',
    'Good (G)',
    'Fair (F)',
    'Poor (P)',
    'Generic',
    'Not Graded',
]);
// Schema for creating a Discogs listing
export const createDiscogsListingSchema = z.object({
    itemId: z.string().uuid(),
    releaseId: z.number().int().positive(),
    mediaCondition: discogsMediaConditionSchema,
    sleeveCondition: discogsSleeveConditionSchema,
    price: z.number().positive(),
    comments: z.string().max(32000).optional(),
});
// Schema for updating a Discogs listing
export const updateDiscogsListingSchema = z.object({
    mediaCondition: discogsMediaConditionSchema,
    sleeveCondition: discogsSleeveConditionSchema,
    price: z.number().positive(),
    comments: z.string().max(32000).optional(),
});
// Schema for Discogs release search
export const discogsReleaseSearchSchema = z.object({
    query: z.string().min(1).max(200),
});
// Schema for OAuth callback
export const discogsCallbackSchema = z.object({
    oauth_token: z.string().min(1),
    oauth_verifier: z.string().min(1),
});
//# sourceMappingURL=discogs.js.map